import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=c4d13c0e&scoped=true&"
import script from "./AppInfo.vue?vue&type=script&lang=js&"
export * from "./AppInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=c4d13c0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d13c0e",
  null
  
)

export default component.exports